import { RadioButton } from 'react-native-paper';
import React from 'react';
import { View } from 'react-native';

import { Typography } from '@components/Typography';
import { makeStyles } from '@providers/Theme';
import { GridContainer, GridItem, GridItemSpanValue } from '@components/Grid';

export type RadioGroupItem = {
  value: string;
  label: string;
  hide?: boolean;
};

type RadioGroupProps = {
  value?: RadioGroupItem | null;
  items: RadioGroupItem[];
  testID?: string;
  size?: GridItemSpanValue;
  disabled?: boolean;
  onItemPress?: (item: RadioGroupItem, value: string) => void;
};

const useStyles = makeStyles({
  root: {},
  listItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  item: {
    flex: 1,
  },
  label: {
    flex: 1,
  },
  children: {
    marginHorizontal: 24,
  },
  grid: {
    backgroundColor: 'white',
    width: '100%',
  },
});

export const RadioGroup: React.FC<RadioGroupProps> = ({
  value: checkedValue,
  items,
  testID,
  onItemPress,
  size,
  disabled,
}) => {
  const styles = useStyles();

  const renderItems = () =>
    items.map(
      (item, i: number) =>
        !item.hide && (
          <GridItem key={'radio-' + i} xs={size ?? 12} testID="grid-item">
            <View style={styles.listItem}>
              <RadioButton
                testID={'radio-' + i}
                status={
                  item.value === checkedValue?.value ? 'checked' : 'unchecked'
                }
                value={item.value}
                color="#F02A00"
                onPress={() => {
                  onItemPress?.(item, item.value);
                }}
                disabled={disabled}
              />
              <Typography
                size={{ xs: 'sm', lg: 'md' }}
                weight="medium"
                style={styles.label}>
                {item.label}
              </Typography>
            </View>
          </GridItem>
        ),
    );

  return (
    <View style={styles.root} testID={testID}>
      <GridContainer classes={{ root: styles.grid }}>
        {renderItems()}
      </GridContainer>
    </View>
  );
};
